import React, { PureComponent } from "react";
import { GridRow, GridColumn } from "arv-reactcomponents";

class LoyaltyTierBody extends PureComponent {
  render() {
    const { tiers } = this.props;
    return (
      <GridRow className="nw-loyaltymodal-tierdata nwc-custom-scrollbar">
        <GridColumn>
          {tiers.map(tier => (
            <GridRow className="nw-loyaltymodal-tiers">
              <GridColumn className="nwc-grid-col-xs-4 nw-loyaltymodal-tiernametext">
                {tier.type}
              </GridColumn>
              <GridColumn className="nwc-grid-col-xs-4 nw-loyaltymodal-textcenter">
                {tier.criteria}
              </GridColumn>
              <GridColumn className="nwc-grid-col-xs-4 nw-loyaltymodal-textright">
                {tier.earn}
              </GridColumn>
            </GridRow>
          ))}
        </GridColumn>
      </GridRow>
    );
  }
}

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrappedComponent: LoyaltyTierBody,
  component: LoyaltyTierBody,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/MyAccountComponent/MyAccountLoyalty/LoyaltyMoreInfoModal/LoyaltyTiersBlock/LoyaltyTierBody/index.js